import { getCurrentWindow } from '@tauri-apps/api/window';
import { isTauriApp } from 'utils/is-tauri';
export const QUICK_ENTRY_WINDOW_LABEL = 'quick-entry';
export const MAIN_WINDOW_LABEL = 'main';
/**
 * Sync label check for the current Tauri webview.
 * Returns null outside Tauri or if the API is unavailable.
 */ export const getTauriWindowLabel = ()=>{
    if (!isTauriApp()) {
        return null;
    }
    try {
        return getCurrentWindow().label;
    } catch (unused) {
        return null;
    }
};
export const isQuickEntryWindow = ()=>getTauriWindowLabel() === QUICK_ENTRY_WINDOW_LABEL;
